import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FaTelegram } from 'react-icons/fa';
import { SOCIAL_LINKS } from '../constants';
import { colors } from '../theme/colors';

const Rail = styled(motion.aside)`
  position: fixed;
  left: clamp(12px, 3vw, 24px);
  top: 50%;
  transform: translateY(-50%);
  z-index: 900;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const IconLink = styled(motion.a)`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(15, 23, 42, 0.08);
  color: #475569;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: color 0.2s, border-color 0.2s;

  &:hover {
    color: ${colors.accent};
    border-color: rgba(15, 118, 110, 0.28);
  }
`;

const ICONS = {
  telegram: FaTelegram,
};

const fadeIn = {
  hidden: { opacity: 0, x: -12 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.5, delay: 0.2 } },
};

function SocialLinks() {
  return (
    <Rail initial="hidden" animate="visible" variants={fadeIn} aria-label="Community links">
      {SOCIAL_LINKS.map((link) => {
        const Icon = ICONS[link.icon];
        return (
          <IconLink
            key={link.icon}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={link.label}
            whileHover={{ scale: 1.06 }}
          >
            <Icon />
          </IconLink>
        );
      })}
    </Rail>
  );
}

export default SocialLinks;
